import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'monorepo-update-qty-modal',
  templateUrl: './update-qty-modal.component.html',
  styleUrls: ['./update-qty-modal.component.scss'],
})
export class UpdateQtyModalComponent implements OnInit {
  @Input() maxRange: number = 0;
  @Input() selectedActualQty: number = 0;
  constructor(private modalController: ModalController, private translate: TranslateService) {}

  ngOnInit(): void {}

  subtract() {
    this.selectedActualQty = this.selectedActualQty > 1 ? this.selectedActualQty - 1 : this.selectedActualQty;
  }

  add() {
    this.selectedActualQty = this.selectedActualQty + 1 > this.maxRange ? this.maxRange : this.selectedActualQty + 1;
  }

  save() {
    this.modalController.dismiss(this.selectedActualQty, 'SAVE');
  }

  cancel() {
    this.modalController.dismiss();
  }
}
